import { ActionIcon, Button, Grid, Group, Select, Space, Text } from '@mantine/core';
import { Paper } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { BiArrowBack } from 'react-icons/bi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import base from '../../apis';
import Modal from '../../components/Modal/Modal';
import Spinner from '../../components/Spinner/Spinner';
import { getCallStatus } from '../../utils/functions';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { useSelector } from 'react-redux';

const filterStatus = [
  { label: 'Not Interested', value: 'NI' },
  { label: 'Did Not Answer', value: 'NA' },
  { label: 'Do Not Call Back', value: 'DC' },
  { label: 'Call/Call Back', value: 'CB' },
  { label: 'Scheduled Virtual Appointment', value: 'SZ' },
  { label: 'Call Completed', value: 'CC' },
];

const addColor = (theme) => ({
  root: {
    backgroundColor: '#1378a5',
    '&:hover': {
      backgroundColor: theme.fn.darken('#1378a5', 0.05),
    },
  },
});

function OfficeDetails() {
  const { id } = useParams();
  const [tasks, setTasks] = useState([]);
  const [backedTasks, setBackedTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [officeDetails, setOfficeDetails] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const role = useSelector((state) => state.auth.role);
  useEffect(() => {
    setIsLoading(true);
    const urls = [`/operations/offices/${id}/tasks/`, `/operations/offices/${id}/`];
    Promise.all(urls.map((url) => base.get(url)))
      .then((res) => {
        setTasks(res[0].data);
        setBackedTasks(res[0].data);
        setOfficeDetails(res[1].data);
      })
      .catch((err) => {
        toast.warn('Error getting office details');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  const onFilter = (value) => {
    let filtered = [];
    if (!value) filtered = [...backedTasks];
    else {
      filtered = backedTasks.filter((task) => task.call_status === value);
    }
    setTasks(filtered);
  };

  const viewDetails = (agent) => {
    setSelectedAgent(agent);
    setDetailsModal(true);
  };

  const navigate = useNavigate();

  const onApprove = (approve = true) => {
    setIsLoading(true);
    base
      .post(`/operations/${!approve ? 'dis' : ''}approve_office/`, { office_id: +id })
      .then(() => {
        toast.success(`Office ${approve ? 'approved' : 'rejected'} successfully`);
        navigate('/office-status');
      })
      .catch(() => {
        toast.warn('Error submitting office');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Spinner />}
      <Modal open={detailsModal} onClose={() => setDetailsModal(false)}>
        <div className="mod2" style={{ minWidth: '70vw', paddingBottom: '20px' }}>
          <div className="mod2header">
            <div>
              <p>{officeDetails?.branch}</p>
              <p>{officeDetails?.city}</p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModal(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="bigg">
            <div>
              <p>
                Agent's Name: <b>{`${selectedAgent?.agent_first_name} ${selectedAgent?.agent_last_name}`}</b>
              </p>
              <p>
                Agent's Number: <b>{selectedAgent?.agent_phone}</b>
              </p>
              <p>
                Agent's Email: <b>{selectedAgent?.agent_email}</b>
              </p>
              <p>
                Agent's Office: <b>{officeDetails?.branch}</b>&nbsp;&nbsp;&nbsp;&nbsp;
              </p>
              <div>
                <p>Comment Section</p>
                <div
                  style={{
                    border: '1px solid black',
                    padding: '5px',
                    backgroundColor: '#F9F9FB',
                    borderRadius: '5px',
                  }}>
                  {selectedAgent?.comment}
                </div>
              </div>
            </div>
            <div>
              <p>
                Last Contacted:{' '}
                <b>
                  {new Date(selectedAgent?.last_call).toLocaleString('en', {
                    weekday: 'long',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </b>
              </p>
              <p>
                Status of Call:{' '}
                <span style={{ color: 'var(--primary-color)' }}>{getCallStatus(selectedAgent?.call_status)}</span>
              </p>

              {selectedAgent?.next_call && (
                <p>
                  Next Call:{' '}
                  <b>
                    {new Date(selectedAgent?.next_call).toLocaleString('en', {
                      weekday: 'long',
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </b>
                </p>
              )}

              {/* <button className="call">
                <BsFillTelephoneFill /> <b>Call Agent</b>
              </button> */}
            </div>
          </div>
        </div>
      </Modal>
      <Box p="20px">
        <Box display="flex" justifyContent="space-between">
          <Select placeholder="Filter by status" data={filterStatus} clearable onChange={onFilter} />

          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" gap="10px">
              <ActionIcon component={Link} to={role === 'snr_marketer' ? '/office-status' : '/submitted-offices'}>
                <BiArrowBack fontSize={'30px'} color="var(--primary-color)" />
              </ActionIcon>
              <Text weight={700}>{officeDetails?.branch}</Text>
            </Box>
            <Space w="md" />
            <Text align="right">
              {officeDetails?.city}, {officeDetails?.state}, {officeDetails?.zip_code}
            </Text>
          </Box>
        </Box>
        {role === 'snr_marketer' && (
          <Group position="right" mt="md">
            <Button variant="filled" styles={addColor} onClick={() => onApprove(true)}>
              Approve
            </Button>
            <Button
              variant="outline"
              onClick={() => onApprove(false)}
              styles={(theme) => ({
                root: {
                  color: '#1378a5',
                  borderColor: '#1378a5',
                  '&:hover': {
                    color: theme.fn.darken('#1378a5', 0.05),
                  },
                },
              })}>
              Reject
            </Button>
          </Group>
        )}
        <Grid gutter={20} mt="md">
          {tasks.map((task) => (
            <Grid.Col span={4} key={task.id} onClick={() => viewDetails(task)}>
              <Paper style={{ backgroundColor: '#eaf8ff', padding: '5px 10px', cursor: 'pointer' }}>
                <Box padding="10px">
                  <Box my="15px">
                    <b style={{ color: 'var(--primary-color)' }}>
                      {task.agent_first_name} {task.agent_last_name}
                    </b>
                  </Box>
                  <Box my="15px">
                    <Text>Last Call Status</Text>
                    <Text>{getCallStatus(task.call_status)}</Text>
                  </Box>
                  <Box my="15px">
                    <Text>Last Contacted</Text>
                    <Text>
                      {new Date(task.last_call).toLocaleDateString('en', {
                        weekday: 'short',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </Text>
                  </Box>
                </Box>
              </Paper>
            </Grid.Col>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default OfficeDetails;
